import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { AuthGuard } from '../../../common/guards/auth.guard';
import { environment } from '../../../../environments/environment';
import { CommunicationService } from '../../../common/services/Communication.service';
import { dataModel } from '../../../models/data.model';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-request-access',
  templateUrl: './request-access.component.html',
  styleUrls: ['./request-access.component.sass'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate(2000)),
    ]),
  ]
})

export class RequestAccessComponent implements OnInit {
  submitted = false;
  contactForm = new FormGroup({
    fname: new FormControl('', Validators.required),
    sname: new FormControl('', Validators.required),
    email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
    ])),
    company: new FormControl('', Validators.required),
    phone: new FormControl(''),
    subject: new FormControl('', Validators.required),
    gdpr: new FormControl(''),
    recaptchaReactive: new FormControl(null, Validators.required),
  });

  constructor(
    private authService: AuthGuard,
    communicationService: CommunicationService) {
    this.data = communicationService.data;
  }

  data: dataModel;
  ngOnInit() { }

  // Resolved Captcha
  public resolved(captchaResponse: any) {
    this.contactForm.controls.recaptchaReactive.setValue(captchaResponse);
  }

  // Checkbox
  checkBox(event: any) {
    this.contactForm.patchValue({
        gdpr: event.target.checked
    });
  }

  // Body Message
  createMessageBody() {
    const body = '<!DOCTYPE html>\n' +
      '<html>\n' +
      '    <head>\n' +
      '        <title>Marcus Evans Case Studies - We have received your request and we will be in touch soon!</title>' +
      '        <meta charset="utf-8" />' +
      '        <style>\n' +
      '            body {font-family : Calibri}' +
      '        </style>' +
      '    </head>' +
      '    <body style="padding:10px;margin:10px !important; ">' +
      '        <h2>Enquiry Details</h2>' +
      `        <p><b>First Name</b>: ${this.contactForm.controls.fname.value}</p> ` +
      `        <p><b>Surname</b>: ${this.contactForm.controls.sname.value}</p> ` +
      `        <p><b>Email Address</b>: ${this.contactForm.controls.email.value}</p> ` +
      `        <p><b>Company Name</b>: ${this.contactForm.controls.company.value}</p> ` +
      `        <p><b>Message</b>: ${this.contactForm.controls.subject.value}</p> ` +
      `        <p><b>Members of the marcus evans Group can send me details about their products, insights, and events</b>: ${this.contactForm.controls.gdpr.value}</p>` +
      '    </body>' +
      '</html>';
    return body;
  }

  // Submit Form
  onSubmit() {
    this.submitted = true;
    const emailRequest = {
      EmailType: environment.emailType,
      EmailTo: environment.emailTo,
      EmailCC: '',
      Subject: 'Re:- Case Study Information Request',
      Body: this.createMessageBody(),
      Provider: environment.emailProvider
    };
    this.authService.isFormSubmitted(emailRequest, this.contactForm.controls.fname.value);
  }

}
